export default __webpack_public_path__ + "static/media/palvelinkauppa.8ed0c687.png";